import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmps-eval-score-alert',
    templateUrl: './score-alert.component.html',
    host: {
        class: 'cmps-eval-score-alert',
    },
})
export class ScoreAlertComponent {
    @Input() label: string;
}
